import type { Components } from '@mildang/mui';
import type { Theme } from '@mildang/mui';

const createChip = ({ typography }: Theme): Components => ({
  MuiChip: {
    styleOverrides: {
      root: {
        borderRadius: 8,
      },
    },
  },
});

export default createChip;
